// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3eBEe","header":"Messages_header__G9pl8"};